import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
@Component({
  selector: 'app-address-confirmation-modal',
  templateUrl: './address-confirmation-modal.component.html',
  styleUrls: ['./address-confirmation-modal.component.css'],
})
export class AddressConfirmationModalComponent {
  @Input() suggestedAddress: string;
  @Input() badAddress: string;

  constructor(private activeModal: NgbActiveModal) {}

  useSuggestedAddress() {
    this.activeModal.close('1');
  }

  keepBadAddress() {
    this.activeModal.close('0');
  }

  cancel() {
    this.activeModal.close('-1');
  }
}
